export default function Holding() {
  return (
    <main className="min-h-screen w-full flex items-center justify-center bg-brand text-brand-cream">
      <h1 className="font-display text-7xl sm:text-8xl md:text-9xl leading-none tracking-tight">Feith</h1>
    </main>
  );
}
